export const HOME_ROUTE =              '/'
export const ABOUT_ROUTE =             '/about'
export const CONTACT_ROUTE =           '/contact'
export const PROFILE_ROUTE =           '/profile'
export const ADD_DONATION_ROUTE =      '/adddonation'
export const SEARCH_ROUTE =            '/searchresult'
export const DONATION_DETAILS_ROUTE =  '/donationdetails/:id?'

